import AiToolPanel from "@/components/ai/AiToolPanel";

const examples = [
  {
    label: "Debounce",
    value: `function debounce(fn, ms){\n  let t;\n  return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };\n}`,
  },
  {
    label: "Python quicksort",
    value: `def qsort(a):\n    if len(a) <= 1: return a\n    p = a[0]\n    return qsort([x for x in a[1:] if x < p]) + [p] + qsort([x for x in a[1:] if x >= p])`,
  },
];

const CodeExplainer = () => (
  <AiToolPanel
    task="code-explain"
    inputLabel="Paste your code"
    placeholder="Paste any function, snippet or file. AI will summarize, walk through and flag issues."
    buttonLabel="Explain code"
    rows={12}
    examples={examples}
  />
);

export default CodeExplainer;